import { render } from "./HistoricoReq.vue?vue&type=template&id=822b07f0"
import script from "./HistoricoReq.vue?vue&type=script&lang=js"
export * from "./HistoricoReq.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__